import script from "./ButtonNeutralTertiary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonNeutralTertiary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonNeutralTertiary.vue?vue&type=style&index=0&id=10c72a06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c72a06"]])

export default __exports__